/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionWindSegment
 */
export interface OutputUavMissionWindSegment {
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionWindSegment
     */
    u?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionWindSegment
     */
    v?: number;
}

/**
 * Check if a given object implements the OutputUavMissionWindSegment interface.
 */
export function instanceOfOutputUavMissionWindSegment(value: object): boolean {
    return true;
}

export function OutputUavMissionWindSegmentFromJSON(json: any): OutputUavMissionWindSegment {
    return OutputUavMissionWindSegmentFromJSONTyped(json, false);
}

export function OutputUavMissionWindSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionWindSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'u': json['u'] == null ? undefined : json['u'],
        'v': json['v'] == null ? undefined : json['v'],
    };
}

export function OutputUavMissionWindSegmentToJSON(value?: OutputUavMissionWindSegment | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'u': value['u'],
        'v': value['v'],
    };
}

